export const isApplicationJson = (contentType: string) => /^application\/json/i.test(contentType);
